import seoDefaults from '../../seo-defaults.json';

// Default SEO texts live in src/seo-defaults.json, shared with the server in server/.
export const SEO_DEFAULTS = seoDefaults;
export const BASIC_SEO_IMG = seoDefaults.defaultImage;

export const DONATE_LINK = 'https://www.patreon.com/radioplato';
